/* ConvertMate · PDP Del Bosque
   <cm-pdp-product>: selector de packs (radios → input name="id" del form principal), galería móvil con miniaturas, tabs.
   <cm-pdp-sticky>: barra fija con IntersectionObserver, sincronizada por `cm:variant-change`.
   Precios: vienen formateados por Shopify en data-* (money), el JS no formatea moneda. */
(() => {
  if (customElements.get('cm-pdp-product')) return;

  class CmPdpProduct extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.packs = Array.from(this.querySelectorAll('input[data-cm-pack]'));
      this.packs.forEach((input) => input.addEventListener('change', () => { if (input.checked) this.select(input); }));
      this.initGallery();
      this.initVideos();
      this.initTabs();
    }

    select(input) {
      const form = document.getElementById(this.formId);
      const idInput = form && form.querySelector('[data-cm-variant-id], input[name="id"]');
      if (idInput) {
        idInput.value = input.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const qtyInput = form && form.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.value = input.dataset.qty || 1;
      const d = input.dataset;
      const variant = {
        id: Number(input.value),
        title: d.title || '',
        price: Number(d.priceCents || 0),
        price_formatted: d.price || '',
        compare_formatted: d.compare || '',
        save_formatted: d.save || '',
        available: d.available !== 'false',
        image: d.image || '',
      };
      document.querySelectorAll('[data-cm-atc-for="' + this.formId + '"]').forEach((btn) => {
        btn.disabled = !variant.available;
        const label = btn.querySelector('[data-cm-atc-label]');
        if (label) label.textContent = variant.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
        const extra = btn.querySelector('[data-cm-atc-extra]');
        if (extra) extra.hidden = !variant.available;
        const price = btn.querySelector('[data-cm-atc-price]');
        if (price) price.textContent = variant.price_formatted;
      });
      document.dispatchEvent(new CustomEvent('cm:variant-change', {
        detail: { sectionId: this.dataset.sectionId, formId: this.formId, variant },
      }));
    }

    initGallery() {
      const list = this.querySelector('[data-cm-gallery]');
      const thumbs = Array.from(this.querySelectorAll('[data-cm-thumb]'));
      if (!list || !thumbs.length) return;
      const items = Array.from(list.children);
      const setActive = (i) => thumbs.forEach((t, j) => t.setAttribute('aria-current', String(i === j)));
      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        const item = items[i];
        if (!item) return;
        list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' });
        setActive(i);
      }));
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > 0.6) setActive(items.indexOf(e.target)); });
        }, { root: list, threshold: [0.6] });
        items.forEach((it) => io.observe(it));
      }
    }

    // Videos de la galería: YouTube/Vimeo sin iframe hasta que tocan play (con sonido, controles y loop).
    // Al salir el slide de la vista se pausan (iframe y <video> de Shopify).
    initVideos() {
      const yts = Array.from(this.querySelectorAll('[data-cm-yt]'));
      const vids = Array.from(this.querySelectorAll('.cm-pdp-gal__item > video'));
      const ytSrc = (el) => {
        const id = el.dataset.cmYt;
        if (el.dataset.cmYtHost === 'vimeo') return 'https://player.vimeo.com/video/' + id + '?autoplay=1&loop=1';
        return 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&loop=1&playlist=' + id + '&playsinline=1&rel=0&modestbranding=1&enablejsapi=1';
      };
      yts.forEach((el) => {
        const btn = el.querySelector('[data-cm-yt-play]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          if (el.querySelector('iframe')) return;
          const frame = document.createElement('iframe');
          frame.src = ytSrc(el);
          frame.title = 'Video del producto';
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.setAttribute('allowfullscreen', '');
          el.appendChild(frame);
          el.classList.add('is-playing');
        });
      });
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) return;
          const el = e.target;
          if (el.tagName === 'VIDEO') { el.pause(); return; }
          const frame = el.querySelector('iframe');
          if (frame && frame.contentWindow) {
            frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
            frame.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
          }
        });
      }, { threshold: [0] });
      yts.concat(vids).forEach((el) => io.observe(el));
    }

    initTabs() {
      this.querySelectorAll('[data-cm-tabs]').forEach((wrap) => {
        const tabs = Array.from(wrap.querySelectorAll('[role="tab"]'));
        const show = (tab, focus) => {
          tabs.forEach((t) => {
            const on = t === tab;
            t.setAttribute('aria-selected', String(on));
            t.tabIndex = on ? 0 : -1;
            const panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
          if (focus) tab.focus();
        };
        tabs.forEach((t, i) => {
          t.addEventListener('click', () => show(t));
          t.addEventListener('keydown', (e) => {
            let n = null;
            if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
            if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
            if (e.key === 'Home') n = tabs[0];
            if (e.key === 'End') n = tabs[tabs.length - 1];
            if (n) { e.preventDefault(); show(n, true); }
          });
        });
      });
    }
  }
  customElements.define('cm-pdp-product', CmPdpProduct);

  class CmPdpSticky extends HTMLElement {
    connectedCallback() {
      this.onVariant = (e) => { if (e.detail && e.detail.formId === this.dataset.formId) this.render(e.detail.variant); };
      document.addEventListener('cm:variant-change', this.onVariant);
      const form = document.getElementById(this.dataset.formId);
      const cta = form && form.querySelector('[data-cm-main-atc]');
      if (!cta || !('IntersectionObserver' in window)) return;
      this.pastCta = false;
      this.footerIn = false;
      this.ctaIO = new IntersectionObserver((entries) => {
        entries.forEach((e) => { this.pastCta = !e.isIntersecting && e.boundingClientRect.top < 0; });
        this.update();
      });
      this.ctaIO.observe(cta);
      const footer = document.querySelector(this.dataset.footerSelector);
      if (footer) {
        this.footIO = new IntersectionObserver((entries) => {
          entries.forEach((e) => { this.footerIn = e.isIntersecting; });
          this.update();
        });
        this.footIO.observe(footer);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cm:variant-change', this.onVariant);
      if (this.ctaIO) this.ctaIO.disconnect();
      if (this.footIO) this.footIO.disconnect();
      document.body.classList.remove('cm-pdp-sticky-visible');
    }

    update() {
      const show = this.pastCta && !this.footerIn;
      this.classList.toggle('is-visible', show);
      this.toggleAttribute('inert', !show);
      this.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('cm-pdp-sticky-visible', show);
    }

    render(v) {
      const q = (s) => this.querySelector(s);
      if (q('[data-cm-sticky-title]') && v.title) q('[data-cm-sticky-title]').textContent = v.title;
      if (q('[data-cm-sticky-price]')) q('[data-cm-sticky-price]').textContent = v.price_formatted;
      const cmp = q('[data-cm-sticky-compare]');
      if (cmp) { cmp.textContent = v.compare_formatted; cmp.hidden = !v.compare_formatted; }
      this.querySelectorAll('[data-cm-sticky-save]').forEach((el) => {
        el.textContent = v.save_formatted ? 'Ahorras ' + v.save_formatted : '';
        el.hidden = !v.save_formatted;
      });
      const img = this.querySelector('[data-cm-sticky-product] img');
      if (img && v.image) { img.src = v.image; img.removeAttribute('srcset'); }
    }
  }
  customElements.define('cm-pdp-sticky', CmPdpSticky);
})();
